import React from 'react';
import styled from 'styled-components';

import { useBankrollQuery } from '#/api/queries/bankrollQueries';
import Button from '#/components/basic/Button/Button';

import { DEFAULT_WELCOME_BONUS_MESSAGE } from './bankrollFn';
import BankrollMessage from './BankrollMessage';
import BankrollModalLayout from './BankrollModalLayout';

const ExplainText = styled.div`
  line-height: normal;
  padding: 0 4px 1px;
  font-size: var(--medium);
  line-height: normal;
`;

const SuccessText = styled(ExplainText)`
  color: var(--white);
  padding-top: 4px;
  padding-bottom: 24px;
`;

export default function BankrollAppliedModal({
  bankrollCode,
  message,
  onClose,
}: {
  bankrollCode: string | undefined;
  message: string | undefined;
  onClose: () => void;
}) {
  const { data: bankrollData } = useBankrollQuery(bankrollCode);

  return (
    <BankrollModalLayout
      quantity={bankrollData?.bankroll?.quantity}
      onClose={onClose}
    >
      <SuccessText>
        {message ? (
          <BankrollMessage message={message} />
        ) : bankrollCode ? (
          <span>Funding secured, happy trading!</span>
        ) : (
          DEFAULT_WELCOME_BONUS_MESSAGE
        )}
      </SuccessText>
      <div>
        <Button onClick={onClose} bordered inline widePadding>
          Start Trading
        </Button>
      </div>
    </BankrollModalLayout>
  );
}
